// extracted by mini-css-extract-plugin
module.exports = {"container":"Candidats_container__3PzUB","location":"Candidats_location__1duoy","list":"Candidats_list__2tRnO"};